module.exports = __webpack_public_path__ + "static/media/icon_sheet.81597342.svg";